import { Customer } from "../../api/schema";
import { ModalInputType } from "../../components/form/Form";
import { FormInputFields } from "../../components/form/InputFormBuilder";
import { UserLanguage } from "../../lang/lang";

export const CreateCustomerModalKeys = (): FormInputFields<Customer> => ({
  name: {
    type: ModalInputType.String,
    label: UserLanguage().data.name,
  },
  invoice_address: { type: ModalInputType.FixedItem, defaultValue: null },
  payment_condition: { type: ModalInputType.FixedItem, defaultValue: null },
});
